import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    listParagraph: {
        textAlign: 'center',
    },
    searchBarContainer: {
        marginBottom: '2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },
    searchBar: {
        minWidth: '450px',
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%',
        },
    },
    emptyStateListItem: {
        border: `2px dashed ${theme.palette.borders.main}`,
        padding: '0.8rem',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));
